import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import BrushMark from "@/components/BrushMark";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/admin/departments", label: "Departments" },
  { to: "/admin/services", label: "Services" },
  { to: "/admin/lawyers", label: "Lawyers" },
  { to: "/admin/insights", label: "Insights" },
  { to: "/admin/contact", label: "Enquiries" },
];

export default function AdminShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (user === false) nav("/admin/login", { replace: true });
  }, [user, nav]);

  if (!user || user === false) {
    return (
      <div className="min-h-screen flex items-center justify-center text-graphite/55" data-testid="admin-checking">
        Checking session…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-warmwhite" data-testid="admin-shell">
      <header className="hairline-bottom">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex items-center justify-between h-20">
          <div className="flex items-center gap-10">
            <BrushMark size={52} />
            <span className="overline text-graphite/55 hidden md:inline">Editorial CMS</span>
          </div>
          <div className="flex items-center gap-8">
            <nav className="flex items-center gap-6">
              {ITEMS.map((i) => (
                <NavLink
                  key={i.to}
                  to={i.to}
                  data-testid={`admin-nav-${i.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `text-sm tracking-[0.15em] uppercase ${isActive ? "text-[#1E3668]" : "text-graphite/70 hover:text-graphite"}`
                  }
                >
                  {i.label}
                </NavLink>
              ))}
            </nav>
            <button onClick={logout} className="text-xs tracking-[0.16em] uppercase text-graphite/60 hover:text-[#1E3668]" data-testid="admin-logout">
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-[1440px] mx-auto px-6 md:px-10 py-12">
        <Outlet />
      </main>
    </div>
  );
}
